import { render, staticRenderFns } from "./FurtherInformation.vue?vue&type=template&id=12252cdb&"
import script from "./FurtherInformation.vue?vue&type=script&lang=ts&"
export * from "./FurtherInformation.vue?vue&type=script&lang=ts&"
import style0 from "./FurtherInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports